import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

import { hideToast, toastsSelector } from './store';
import Toast from './Toast';
import { HideToastCallback } from './types';

function ToastsContainer() {
    const dispatch = useDispatch();
    const toasts = useSelector(toastsSelector);

    const handleHide = useCallback<HideToastCallback>((toastId) => {
        dispatch(hideToast({ toastId }));
    }, [ dispatch ]);

    return (
        <StyledTransitionGroup>
            { toasts.map((toast) => (
                <Toast key={ toast.id }
                    toast={ toast }
                    onHide={ handleHide }
                />
            )) }
        </StyledTransitionGroup>
    );
}

const StyledTransitionGroup = styled(TransitionGroup)`
    position: fixed;
    bottom: ${ ({ theme }) => theme.size.size_30 };
    margin: 0 auto;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${ ({ theme }) => theme.size.size_10 };
    pointer-events: none;
    z-index: 100;
`;

export default memo(ToastsContainer);
